// REACT
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

// COMPONENTS
import Form from "components/Form";
import FormWrapper from "components/Form/form-wrapper";
import InputsGroup from "components/Form/inputs-group";
import SaveChangesButton from "components/Form/save-changes-button";

// STORE ACTIONS
import { editApplication } from "store/actions";

const TrustedAddresses = () => {
    const dispatch = useDispatch();
    const { applicationId } = useParams();
    const { singleApplication } = useSelector((state) => state.applications);
    let defaultValues = {
        trustedIps: singleApplication?.trustedIps || [],
    };
    const onSubmitIps = (data) => {
        dispatch(
            editApplication({
                endpointName: "trustedIps",
                id: applicationId,
                data,
            })
        );
    };
    return (
        <FormWrapper>
            <Form onSubmit={onSubmitIps} defaultValues={defaultValues}>
                <InputsGroup
                    name="trustedIps"
                    inputs={[
                        {
                            name: "",
                            type: "text",
                        },
                    ]}
                />
                <SaveChangesButton />
            </Form>
        </FormWrapper>
    );
};

export default TrustedAddresses;
